import Router from 'vue-router'
import routes from './routes'

export default () => {
    let router =  new Router({
        routes,
        base: process.env.VUE_APP_MODE == 'test' ? '/test' : '/',
        mode: 'history',
        // mode: 'hash',
        linkExactActiveClass: 'exact-active',
        linkActiveClass: 'active',
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                return {
                    x: 0,
                    y: 0
                }
            }
        }
    })
    router.beforeEach((to, from, next) => {
        // console.log(to, from)
        let query = {};
        if (from.query.utm_source) { 
            query.utm_source = from.query.utm_source;
        }
        if (to.matched.some(record => record.meta.requiresAuth) && !localStorage.getItem('token')) {
            toNext(to, from).then(() => {
                next({
                    path: '/login',
                    query: {
                        ...query,
                        redirect: to.fullPath
                    }
                })
            }).catch(() => {
                next({
                    path: '/login',
                    query: {
                        redirect: to.fullPath
                    }
                })
            });
        } else {
            toNext(to, from).then(() => {
                next({
                    path: to.fullPath,
                    query: {
                        ...query
                    }
                });
            }).catch(() => {
                next();
            });
        }
    })
    return router
}

const toNext = (to, from) => {
    return new Promise((resolve, reject) => {
        if (from.name) {
            if (from.query.utm_source && !to.query.utm_source) { 
                resolve();
            } else {
                reject();
            }
        } else {
            reject();
        }
    })
}